import React from "react";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import { inject, observer } from "mobx-react";

import { amber, green } from "@material-ui/core/colors";
import IconButton from "@material-ui/core/IconButton";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Snackbar from "@material-ui/core/Snackbar";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";

class UnstyledSnackbarNotifications extends React.Component {
  static styles(theme) {
    return {
      Success: {
        backgroundColor: green[600]
      },

      Error: {
        backgroundColor: theme.palette.error.dark
      },

      Info: {
        backgroundColor: theme.palette.primary.main
      },

      Warning: {
        backgroundColor: amber[700]
      },

      Icon: {
        fontSize: 20,
      },

      MainIcon: {
        opacity: 0.9,
        marginRight: theme.spacing(1)
      },

      Message: {
        display: "flex",
        alignItems: "center"
      }
    }
  }

  render() {
    const classes = this.props.classes;

    const contentClasses = {
      success: classes.Success,
      warning: classes.Warning,
      error: classes.Error,
      info: classes.Info,
    };

    const icons = {
      success: CheckCircleIcon,
      warning: WarningIcon,
      error: ErrorIcon,
      info: InfoIcon,
    };

    const notifications = this.props.notifications;
    const current = notifications.current();
    const open = !notifications.transitioning && current.variant !== "";
    const contentClass = contentClasses[current.variant] || contentClasses["error"];

    const Icon = icons[current.variant] || icons["error"];

    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={open}
        ClickAwayListenerProps={{ mouseEvent: false }}
        autoHideDuration={5000}
        onClose={notifications.dequeue}
      >
        <SnackbarContent
          className={contentClass}
          message={
            <span className={classes.Message}>
              <Icon className={clsx(classes.Icon, classes.MainIcon)} />
              {current.message + ""}
            </span>
          }
          action={[
            <IconButton key="close" color="inherit" onClick={notifications.dequeue}>
              {" "}<CloseIcon className={classes.Icon} />{" "}
            </IconButton>
          ]}
        />
      </Snackbar>
    )
  }
}

const SnackbarNotifications = withStyles(UnstyledSnackbarNotifications.styles)(
  inject(stores => ({
    notifications: stores.rootStore.notifications(),
  }))(observer(UnstyledSnackbarNotifications))
);
export default SnackbarNotifications;